import { GlLink, GlSprintf } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import FlowUnavailableButton from './flow_unavailable_button.vue?vue3';
export default {
    name: 'RepositoryRequiredButton',
    components: {
        FlowUnavailableButton,
        GlLink,
        GlSprintf
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        projectWebPath: {
            type: String,
            required: true
        },
        size: {
            type: String,
            default: 'small',
            required: false
        },
        variant: {
            type: String,
            default: 'default',
            required: false
        },
        category: {
            type: String,
            default: 'primary',
            required: false
        }
    }
};
